import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

export class ExportFileService {

    exportExcel = (inputData, fileName) => {
        const worksheet = XLSX.utils.json_to_sheet(inputData);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, fileName);
    }

    saveAsExcelFile(buffer, fileName) {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([buffer], {
            type: EXCEL_TYPE
        });

        saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    }

}